import { render, staticRenderFns } from "./ElasticButton.vue?vue&type=template&id=57820a38"
import script from "./ElasticButton.vue?vue&type=script&lang=js"
export * from "./ElasticButton.vue?vue&type=script&lang=js"
import style0 from "./ElasticButton.vue?vue&type=style&index=0&id=57820a38&prod&lang=scss"
import style1 from "./ElasticButton.vue?vue&type=style&index=1&id=57820a38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports